module.exports = __webpack_public_path__ + "img/question2.b9ba1a1b.png";